import React from 'react';
import PropTypes from 'prop-types';
import Button from '@saucelabs/sl-component-buttons';
import PlatformIcon from '@saucelabs/sl-component-platform-icon';

import Styles from './MobileAppInfo.styles';

const MobileAppInfo = ({ name, onClick, platform }) => (
  <div className={Styles.default}>
    <span className={Styles.name}>
      <span className={Styles.icon}>
        <PlatformIcon name={platform} />
      </span>
      {name}
    </span>
    <Button
      category="link"
      onClick={onClick}
    >
      Change
    </Button>
  </div>
);

MobileAppInfo.propTypes = {
  name: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  platform: PropTypes.string.isRequired,
};

export default MobileAppInfo;
